import { render, staticRenderFns } from "./subRowWidget.vue?vue&type=template&id=4e156d3f&scoped=true"
import script from "./subRowWidget.vue?vue&type=script&lang=js"
export * from "./subRowWidget.vue?vue&type=script&lang=js"
import style0 from "./subRowWidget.vue?vue&type=style&index=0&id=4e156d3f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e156d3f",
  null
  
)

export default component.exports